import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { actions } from "../../../reducers/cadastro/roteiros.actions";
import { getRoteiros } from "../../../selectors/cadastro/roteiros.selectors";
import RoteiroPage from "./RoteiroPage";
import {
  actions as routeActions,
  types as routes,
} from "../../../reducers/rotas.actions";
import { getPayload } from "../../../selectors/routes.selectors";

const RoteiroPageConnected = () => {
  const { loading, data, filter, nomeCliente } = useSelector(getRoteiros);
  const cliente = useSelector(getPayload);

  const dispatch = useDispatch();

  const handlePagination = (e, page) => {
    dispatch(
      actions.obterRoteiros.request({
        pagina: page,
        nome: filter,
        idCliente: cliente.id,
      })
    );
  };

  const handleDelete = (e, id) => {
    dispatch(actions.deletarRoteiro.request({ id }));
  };

  const handleActivate = (e, id) => {
    dispatch(actions.reativarRoteiro.request({ id, situacao: "A" }));
  };

  const handleEdit = (e, id) => {
    dispatch(
      routeActions.redirectTo(routes.EDITAR_ROTEIRO, {
        id: id,
      })
    );
  };

  const handleAdd = () => {
    dispatch(routeActions.redirectTo(routes.CRIAR_ROTEIRO, { id: cliente.id }));
  };

  const handleGoBack = () => {
    dispatch(routeActions.redirectTo(routes.CADASTRO_CLIENTE));
  };

  return (
    <RoteiroPage
      data={data}
      loading={loading}
      handlePagination={handlePagination}
      handleAdd={handleAdd}
      handleDelete={handleDelete}
      handleEdit={handleEdit}
      handleGoBack={handleGoBack}
      handleActivate={handleActivate}
      filtroAtual={filter}
      nomeCliente={nomeCliente}
      cliente={cliente}
    />
  );
};

export default RoteiroPageConnected;
